import { useEffect, useState } from 'react';
import { ClickAwayListener, IconButton, Popper } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Container, Footer, Header, Title, TitleContainer } from './styled';
import { AIIcon } from '../../../../sicons';
import { SAILogo } from '../../../../ai';
import { TextColor } from '../../../../../enums';
import SearchForm from '../../../product-match/components/form';
import { SearchFormOptions } from '../../../product-match/enums';
import { SRoundedContainer } from '../../../../sui/srounded-container';
import { ProductMatchValues, productMatchValues } from '../../../product-match';
import { AISearch } from '../..';

interface IntelligenceSearchPopupProps {
  defaultType?: SearchFormOptions;
  search: {
    [key: string]: string | boolean;
  };
  anchorEl: HTMLElement | null;
  onClose?: () => void;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  onClear: () => void;
  onSubmit: (searchType: SearchFormOptions, search: AISearch) => void;
}

const IntelligenceSearchPopup = ({
  defaultType = SearchFormOptions.url,
  search,
  anchorEl,
  onClose,
  onClear,
  onSubmit,
  setAnchorEl
}: IntelligenceSearchPopupProps) => {
  const flags = useFlags();

  const [values, setValues] = useState(productMatchValues);
  const [type, setType] = useState<SearchFormOptions>(defaultType);

  useEffect(() => {
    setType(defaultType);
    Object.keys(search).length > 0 &&
      setValues({ ...productMatchValues, ...search });
  }, [defaultType, search]);

  return (
    <Popper
      disablePortal
      open={!!anchorEl}
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{
        marginTop: -50,
        marginLeft: '-8vw',
        zIndex: 9
      }}>
      <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
        <Container>
          <Header>
            <TitleContainer>
              <AIIcon />
              <Title>What can I help you find?</Title>
            </TitleContainer>

            <IconButton
              onClick={() => {
                onClose?.();
                setAnchorEl(null);
              }}>
              <CloseRoundedIcon
                htmlColor={TextColor.SlateGrey}
                style={{
                  width: 20,
                  height: 20
                }}
              />
            </IconButton>
          </Header>

          <SRoundedContainer style={{ alignSelf: 'stretch' }}>
            <SearchForm
              expanded={false}
              defaultOption={type || SearchFormOptions.text}
              options={[
                SearchFormOptions.text,
                SearchFormOptions.url,
                SearchFormOptions.image,
                ...(flags?.vendorMatch ? [SearchFormOptions.competitor] : [])
              ]}
              values={values}
              height="fit-content"
              onSubmit={onSubmit}
              urlRows={4}
              textRows={4}
              imageTextRows={2}
              onChange={(newValue: { [key: string]: string }) => {
                const key = Object.keys(newValue)?.[0] as SearchFormOptions;
                const newType =
                  newValue[key] === ProductMatchValues.Description
                    ? SearchFormOptions.image
                    : Object.keys(newValue)?.[0];

                setType(newType as SearchFormOptions);

                setValues(prev => ({ ...prev, ...newValue }));

                if (!newValue?.[newType]) onClear?.();
              }}
            />
          </SRoundedContainer>

          <Footer>
            <SAILogo />
          </Footer>
        </Container>
      </ClickAwayListener>
    </Popper>
  );
};

export default IntelligenceSearchPopup;
